import { useEffect } from "react";

export const isEditableOrDialogTarget = (target, hasModalOpen = false) => {
  if (hasModalOpen) return true;
  if (!target || typeof target !== "object") return false;
  const tagName = (target.tagName || "").toUpperCase();
  if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT") {
    return true;
  }
  if (target.isContentEditable) {
    return true;
  }
  if (typeof target.closest === "function" && target.closest('[role="dialog"]')) {
    return true;
  }
  return false;
};

export const useReaderShortcuts = ({
  hasSelection = false,
  hasModalOpen = false,
  onPrevChapter,
  onNextChapter,
  onToggleCatalog,
  onToggleSettings,
  onToggleBookmarks,
  onToggleHelp,
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;

      if (isEditableOrDialogTarget(event.target, hasModalOpen)) {
        return;
      }

      const key = event.key;
      const lower = key.toLowerCase();

      if (key === "ArrowLeft") {
        if (hasSelection) return;
        const nativeSel =
          typeof window !== "undefined" ? window.getSelection?.() : null;
        if (nativeSel && !nativeSel.isCollapsed && nativeSel.toString().trim()) {
          return;
        }
        if (onPrevChapter) {
          event.preventDefault();
          onPrevChapter();
        }
        return;
      }

      if (key === "ArrowRight") {
        if (hasSelection) return;
        const nativeSel =
          typeof window !== "undefined" ? window.getSelection?.() : null;
        if (nativeSel && !nativeSel.isCollapsed && nativeSel.toString().trim()) {
          return;
        }
        if (onNextChapter) {
          event.preventDefault();
          onNextChapter();
        }
        return;
      }

      if (lower === "m" && !event.shiftKey) {
        if (onToggleCatalog) {
          event.preventDefault();
          onToggleCatalog();
        }
        return;
      }

      if (lower === "s" && !event.shiftKey) {
        if (onToggleSettings) {
          event.preventDefault();
          onToggleSettings();
        }
        return;
      }

      if (lower === "b" && !event.shiftKey) {
        if (onToggleBookmarks) {
          event.preventDefault();
          onToggleBookmarks();
        }
        return;
      }

      if (key === "?" || (key === "/" && event.shiftKey)) {
        if (onToggleHelp) {
          event.preventDefault();
          onToggleHelp();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    hasModalOpen,
    hasSelection,
    onNextChapter,
    onPrevChapter,
    onToggleBookmarks,
    onToggleCatalog,
    onToggleHelp,
    onToggleSettings,
  ]);
};

export default useReaderShortcuts;
